import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import React from 'react'
import { Trans } from 'react-i18next'

const OpswatMarketingAlert = () => {
  const { _t } = useTypedTranslation()

  return (
    <p className="h6 mb-4 mt-4 font-weight-bold">
      <Trans
        i18nKey="to-have-access-to-all-features"
        components={{
          link1: <a href="https://www.filescan.io/auth/signin" target="_blank" rel="noreferrer" />,
          link2: (
            <a
              href="https://www.opswat.com/products/metadefender/sandbox?utm_source=fsio&utm_medium=osintrepatxtl&utm_campaign=24_v1"
              target="_blank"
              rel="noreferrer"
            />
          ),
        }}
      />
    </p>
  )
}

export default OpswatMarketingAlert
